import React, { useEffect, useState } from "react";
import { allInputs } from "./QuestionFormInputs";
import GTranslateSharpIcon from "@mui/icons-material/GTranslateSharp";
import { useAppDispatch, useAppSelecter } from "../../../../hooks/storeHooks";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import { inputProp, ObjectValues } from "../../../login";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  Backdrop,
  Box,
  Checkbox,
  Chip,
  FormControlLabel,
  Grid,
  Paper,
  Stack,
  Step,
  StepLabel,
  Tooltip,
  Typography,
} from "@mui/material";
import CustomProgress from "../../../../Components/CustomProgress";
import { rowSB } from "../../../../GlobalStyles";
import MobileEmulator from "../../../contentFeedback/Preview/MobileEmulator";
import CustomIconButton from "../../../../Components/CustomIconButton";
import apiRequest from "../../../../request/apiRequest/apiRequest";
import CustomContainedButton from "../../../../Components/CustomContainedButton";
import {
  ColorlibConnector,
  CssStepperHorizontal,
} from "../../../contentFeedback/EditScreen";
import { subHeading } from "../../../../Components/CustomTexts";
import { copyIcon } from "../../../../assets/svgs";
import copy from "copy-to-clipboard";
import { showSnack } from "../../../../store/slices/constants";
import globalColors from "../../../../globalColors";
import MultipleAutoComplte from "../../../../Components/MultipleAutoComplte";
import { allApis } from "../../../../request/config";
import CustomAutocomplete from "../../../../Components/CustomAutocomplete";
import CustomCkeditor from "../../../../Components/CustomCkeditor";
import { ArrowBack } from "@mui/icons-material";
import ContentConfirmationDialog from "./ContentConfirmationDialog";
import { mappingUpdate } from "../../../../store/slices/QuestionReview/QuestionReviewSlice";
import { singleLineEllipsis } from "../../../../Components/AllCards/layouts/CardHeader";
import LoaderBackdrop from "../../../QuestionClusterMapping/LoaderBackdrop";
import { fetchSinlgQustion } from "../../../../store/slices/detailedMaster/detailedMasterSlice";
import { fetchTagsData } from "../../../../store/slices/exams/thunks/fetchContentData";
import { Question } from "../../Utils";
function FormComp({ question_id, onClose, onSubmit, filters, newPath }: any) {
  const [submittedData, setSubmittedData] = useState<ObjectValues>({
    loader: false,
  });
  const [isEditable, setIsEditable] = useState(true);
  const [dialogState, setDialogState] = useState<{
    open: boolean;
    actionType: "corrected" | "noChange";
  }>({
    open: false,
    actionType: "corrected",
  });
  const [editButtonClicked, setEditButtonClicked] = useState(false);
  const [question, setQuestion] = useState<Question | null>(null);
  const [value, setValue] = useState<0 | 1>(0);

  const [steps, setSteps] = useState(["English"]);

  const [allSubmittedData, setAllSubmittedData] = useState<ObjectValues[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const dispatch = useAppDispatch();
  const userData = useAppSelecter(
    (state: ObjectValues) => state.userSlice.loggedUser
  );
  const [hasFetched, setHasFetched] = useState(false);

  const examsData = useAppSelecter((state: ObjectValues) => state.exams);
  const getHindiData = (que: any) => {
    const single_exam = que;
    const newSubmittedData: any = allSubmittedData[1] || {};
    allInputs(tags_list).map((singleInput: inputProp) => {
      if (single_exam) {
        switch (singleInput.label) {
          case "Explanation":
            if (single_exam.explanation_hi) {
              newSubmittedData[singleInput.label] = single_exam.explanation_hi;
            }

            break;
          case "Option A":
            if (single_exam.options_hi?.option_1_hi) {
              newSubmittedData[singleInput.label] =
                single_exam.options_hi.option_1_hi;
            }
            break;
          case "Option B":
            if (single_exam.options_hi?.option_2_hi) {
              newSubmittedData[singleInput.label] =
                single_exam.options_hi.option_2_hi;
            }

            break;
          case "Option C":
            if (single_exam.options_hi?.option_3_hi) {
              newSubmittedData[singleInput.label] =
                single_exam.options_hi.option_3_hi;
            }
            break;
          case "Option D":
            if (single_exam.options_hi?.option_4_hi) {
              newSubmittedData[singleInput.label] =
                single_exam.options_hi.option_4_hi;
            }
            break;
          case "Question":
            if (single_exam.question_hi) {
              newSubmittedData[singleInput.label] = single_exam.question_hi;
            }
            break;
        }
      }
      return singleInput;
    });
    return newSubmittedData;
  };
  const checkForMissingVal = (object: any): boolean => {
    let notAllFilled = false;
    for (const [key, value] of Object.entries(object).filter(
      ([key, value]) => key !== "loader"
    )) {
      const inputField = allInputs(tags_list).find((a: any) => a.label === key);
      if (!inputField?.not_required) {
        if (value === null || value === undefined || value === "") {
          notAllFilled = true;
          break;
        }
      }
      if (key === "correct_answer") {
        if (value === null || value === undefined || value === "") {
          notAllFilled = true;
          break;
        }
      }
    }
    return notAllFilled || !object.hasOwnProperty("correct_answer");
  };
  const handleOpenDialog = (action: "corrected" | "noChange") => {
    setDialogState({ open: true, actionType: action });
  };
  const isAllMandatoryFieldsFilled = (): boolean => {
    let isMissing: boolean[] = [false, false];
    allSubmittedData &&
      allSubmittedData?.forEach((a, index) => {
        if (!a || Object.entries(a).length === 0) {
          isMissing[index] = true;
          return true;
        }
        isMissing[index] = checkForMissingVal(a);
      });

    const checkForCurrentTab =
      submittedData && checkForMissingVal(submittedData);
    if (checkForCurrentTab) {
      isMissing[value] = true;
    } else {
      const newData = [...allSubmittedData];
      newData[value] = submittedData;
      newData?.forEach((a) => {
        isMissing[value] = false;
        if (!a || Object?.entries(a)?.length === 0) {
          isMissing[value] = true;
          return true;
        }
        isMissing[value] = checkForMissingVal(a);
      });
    }
    return isMissing.some((a) => a);
  };

  const tags_list = examsData.tags_list ?? [];

  const handleInputChange = (
    label: string,
    value: string | number | inputProp | null | boolean,
    id?: any
  ) => {
    if (label === "correct_answer") {
      setSubmittedData((prevDetails) => ({
        ...prevDetails,
        [label]: value,
      }));
      const newData = [...allSubmittedData];
      if (newData[1]) {
        newData[1] = { ...newData[1], [label]: value };
        setAllSubmittedData(newData);
      }
    } else {
      setSubmittedData((prevDetails) => ({
        ...prevDetails,
        [label]: value,
      }));
    }
  };
  const formatPayloadTranslateEach = (data: ObjectValues, label?: string) => {
    const newObj: any = label
      ? label === "Question"
        ? { question: data.Question }
        : label === "Explanation"
        ? { explanation: data.Explanation }
        : {
            options: {
              option_1: data["Option A"],
              option_2: data["Option B"],
              option_3: data["Option C"],
              option_4: data["Option D"],
            },
          }
      : {
          question: data.Question,
          options: {
            option_1: data["Option A"],
            option_2: data["Option B"],
            option_3: data["Option C"],
            option_4: data["Option D"],
          },
          explanation: data.Explanation,
        };
    return newObj;
  };
  useEffect(() => {
    dispatch(fetchTagsData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // getApi
    if (!hasFetched) {
      const getData = async () => {
        const getApi = (id: string) => allApis?.getsinglequestion(id);
        const res = await fetchSinlgQustion({
          api: getApi(question_id ?? ""),
          method: "GET",
          payload: {},
          id: question_id,
        });
        setQuestion(res);
        setSteps(
          res?.languages_available?.includes("hindi")
            ? ["English", "Hindi"]
            : ["English"]
        );
        setValue(res?.default_language === "english" ? 0 : 1);
        setHasFetched(true); // Ensure it runs only once
      };
      getData();
    }

    const newData = {
      ...allSubmittedData[value],
      loader: false,
    };
    setSubmittedData({ ...newData });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasFetched, dispatch]);
  const formatPayloadTranslate = (data: ObjectValues, label?: string) => {
    const fields = [
      "Explanation",
      "Question",
      "Option A",
      "Option B",
      "Option C",
      "Option D",
    ];

    const mismatchedLabels = fields;
    // .filter(
    //   (field) => allSubmittedData[0][field] !== data[field]
    // );
    let newObj: any = {};

    if (mismatchedLabels.includes("Question")) {
      newObj.question = data.Question;
    }

    if (mismatchedLabels.includes("Explanation")) {
      newObj.explanation = data.Explanation;
    }

    const optionLabels = ["Option A", "Option B", "Option C", "Option D"];
    if (mismatchedLabels.some((lbl) => optionLabels.includes(lbl))) {
      newObj.options = {
        option_1: data["Option A"],
        option_2: data["Option B"],
        option_3: data["Option C"],
        option_4: data["Option D"],
      };
    }

    return newObj;
  };

  // const handleCommnet = async (remark: any) => {
  //   await apiRequest({
  //     api: allApis.comments.post,
  //     method: "POST",
  //     payload: {
  //       question: question_id,
  //       comment: remark,
  //       type: "question_cluster_review",
  //     },
  //   });
  // };

  const queUpdate = async (remark: string) => {
    let allData: any[] = [];
    const newData = [...allSubmittedData];
    newData[value] = submittedData;
    const formatPayload = (data: ObjectValues, language?: any) => {
      const newObj: any = {
        text: data.Question,
        tag:
          data["Question Tags"]?.length > 0 && language === "english"
            ? data["Question Tags"]?.map((it: any) => it.id)
            : [],
        options: [
          {
            text: data["Option A"],
            is_correct:
              data.correct_answer?.label === "Option A" ? true : false,
            media_urls: "",
            order: 1,
          },
          {
            text: data["Option B"],
            is_correct:
              data.correct_answer?.label === "Option B" ? true : false,
            media_urls: "",
            order: 2,
          },
          {
            text: data["Option C"],
            is_correct:
              data.correct_answer?.label === "Option C" ? true : false,
            media_urls: "",
            order: 3,
          },
          {
            text: data["Option D"],
            is_correct:
              data.correct_answer?.label === "Option D" ? true : false,
            media_urls: "",
            order: 4,
          },
        ],
        explanation: {
          media_urls: "",
          text: data.Explanation,
        },
        language: language,
        media_urls: "",
      };
      return newObj;
    };
    allData = newData
      .filter((data) => Object.keys(data).length > 0)
      .map((data, i) => {
        if (formatPayload) {
          return formatPayload(data, i === 0 ? "english" : "hindi");
        }
        return data;
      });
    const response: any = await apiRequest({
      api: `cms/content/nw-question/create/`,
      payload: {
        cluster_id: filters.cluster.id,
        question_id: question_id,

        english: allData.find((s) => s.language === "english") ?? {},
        hindi: allData.find((s) => s.language === "hindi") ?? {},
      },
      method: "POST",
    });

    if (response === undefined || (response && response.error)) {
      await setSubmittedData((p) => {
        return { ...p, loader: false };
      });
      setDialogState((prev) => ({ ...prev, open: false }));
      setIsSubmitting(false);
       await dispatch(
        showSnack({
          message: response.msg??"Something went wrong, please try again later.",
          severity: "error",
          open: true,
        })
      );
      return response;
    } else {
     

      onSubmit(question);
      dispatch(
        showSnack({
          message:
            dialogState.actionType === "corrected"
              ? "Question updated successfully!"
              : "No correction needed.",
          severity: "success",
          open: true,
        })
      );

      await setSubmittedData((p) => {
        return { ...p, loader: false };
      });
      setDialogState((prev) => ({ ...prev, open: false }));
      setIsSubmitting(false);
    }
  };
  const handleConfirmDialog = async (remark: string) => {
    setIsSubmitting(true);

    queUpdate(remark);
  };

  const fomratQuestionData = (question: any, language: any) => {
    const single_exam = question;

    const newSubmittedData: any = {};
    allInputs(tags_list).map((singleInput: inputProp) => {
      if (single_exam) {
        switch (singleInput.label) {
          case "Question Tags":
            newSubmittedData[singleInput.label] = single_exam.tag
              ? singleInput.list?.filter((item) =>
                  single_exam.tag
                    .map((ss: any) => ss.id ?? ss)
                    .includes(item.id)
                )
              : [];

            break;
          case "Explanation":
            newSubmittedData[singleInput.label] =
              single_exam.explanation?.translation?.length > 0
                ? single_exam.explanation?.translation?.find(
                    (item: { language: any }) => item.language === language
                  )?.text ?? ""
                : single_exam.explanation?.translation?.text ?? "";

            break;
          case "Option A":
            newSubmittedData[singleInput.label] =
              single_exam.options[0]?.translation?.length > 0
                ? single_exam.options[0]?.translation?.find(
                    (item: { language: any }) => item.language === language
                  )?.text ?? ""
                : single_exam.options[0]?.translation?.text ?? "";
            if (single_exam.options[0]?.is_correct) {
              newSubmittedData[`correct_answer`] = singleInput;
            }
            break;
          case "Option B":
            newSubmittedData[singleInput.label] =
              single_exam.options[1]?.translation?.length > 0
                ? single_exam.options[1]?.translation?.find(
                    (item: { language: any }) => item.language === language
                  )?.text ?? ""
                : single_exam.options[1]?.translation?.text ?? "";
            if (single_exam.options[1]?.is_correct) {
              newSubmittedData[`correct_answer`] = singleInput;
            }
            break;
          case "Option C":
            newSubmittedData[singleInput.label] =
              single_exam.options[2]?.translation?.length > 0
                ? single_exam.options[2]?.translation?.find(
                    (item: { language: any }) => item.language === language
                  )?.text ?? ""
                : single_exam.options[2]?.translation?.text ?? "";
            if (single_exam.options[2]?.is_correct) {
              newSubmittedData[`correct_answer`] = singleInput;
            }
            break;
          case "Option D":
            newSubmittedData[singleInput.label] =
              single_exam.options[3]?.translation?.length > 0
                ? single_exam.options[3]?.translation?.find(
                    (item: { language: any }) => item.language === language
                  )?.text ?? ""
                : single_exam.options[3]?.translation?.text ?? "";
            if (single_exam.options[3]?.is_correct) {
              newSubmittedData[`correct_answer`] = singleInput;
            }
            break;
          case "Question":
            newSubmittedData[singleInput.label] =
              Array.isArray(single_exam.translation) &&
              single_exam.translation?.length > 0
                ? single_exam.translation?.find(
                    (item: { language: any }) => item.language === language
                  )?.text ?? ""
                : single_exam?.translation?.text ?? "";

            break;
        }
      }
      return singleInput;
    });
    return newSubmittedData;
  };
  const handleChange = async (newValue: 0 | 1, no?: "No") => {
    // Set loading state first, then proceed with the rest of the logic in a separate tick
    setSubmittedData((p) => ({
      ...p,
      loader: true,
      loader_text:
        newValue === 1 && !no ? "Translating english Content to hindi." : "",
    }));

    setTimeout(async () => {
      if (newValue === 1 && !no) {
        const payload = formatPayloadTranslate(submittedData);
        if (Object.keys(payload).length > 0) {
          const response: any = await apiRequest({
            api: `content/v3/translate-text/`,
            payload: payload,
            method: "POST",
          });
          const newData = [];
          newData[0] = submittedData;
          newData[1] = getHindiData(response);
          setAllSubmittedData(newData);

          setValue(newValue);
          setSubmittedData({ ...newData[newValue], loader: false });
        } else {
          setValue(newValue);
          const newData = [...allSubmittedData];
          newData[value] = submittedData;
          setAllSubmittedData(newData);
          setSubmittedData({ ...allSubmittedData[newValue], loader: false });
        }
      } else {
        setValue(newValue);
        const newData = [...allSubmittedData];
        newData[value] = submittedData;
        setAllSubmittedData(newData);
        setSubmittedData({ ...allSubmittedData[newValue], loader: false });
      }
    }, 0);
  };
  useEffect(() => {
    if (question && question_id && question !== null) {
      // const tabs = question?.languages_available
      //   ? question?.languages_available.split(",")
      //   : [question?.default_language];
      const all_languages = question.translation
        ? question.translation.map((s: { language: any }) => s.language)
        : [];

      if (all_languages.length > 0) {
        const eng = fomratQuestionData(question, "english");
        const hindi =
          all_languages.length > 1
            ? fomratQuestionData(question, "hindi")
            : undefined;
        const finaldata = hindi ? [eng, hindi] : [eng];
        setValue(question?.default_language === "english" ? 0 : 1);
        // let data = questionArray.map((q:any) => (getEditSubmittedData(q.res.id, q.res)))
        setAllSubmittedData(finaldata);

        const newData = {
          ...finaldata[question?.default_language === "english" ? 0 : 1],
          loader: false,
        };

        setSubmittedData({ ...newData });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [question]);

  const oneContentWidth = {
    maxWidth: "100%",
    width: "100%",
  };

  const fullWidthSx = { width: "100%" };
  const singleForm: any = (input: inputProp, i: number) => {
    const headingContent = subHeading({
      sx: { flex: 8 },
      parentSx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row",
      },
      text: `${input.label} ${input.not_required === true ? "" : "*"}`,
      icon:
        (value === 0 || value === 1) &&
        isEditable &&
        (input.label === "Question" || input.label === "Explanation") ? (
          <Box
            sx={{
              width: "fit-content",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            {steps.length > 1 && (
              <Tooltip title={`Translate ${input.label}`} arrow>
                <Box
                  sx={{
                    margin: "0",
                    cursor: "pointer",
                    minWidth: "fit-content",
                    padding: "2px !important",
                  }}
                  onClick={async () => {
                    setSubmittedData((p) => {
                      return {
                        ...p,
                        loader: true,
                        loader_text: `Translating ${input.label} to hindi.`,
                      };
                    });

                    const response: any = await apiRequest({
                      api: `content/v3/translate-text/`,
                      payload: formatPayloadTranslateEach(
                        value === 0 ? submittedData : allSubmittedData[0],
                        input.label
                      ),
                      method: "POST",
                    });
                    const newData = [];
                    newData[0] =
                      value === 0 ? submittedData : allSubmittedData[0];
                    newData[1] = getHindiData(response);
                    setAllSubmittedData(newData);

                    setSubmittedData({
                      ...newData[value],
                      loader: false,
                    });
                  }}
                >
                  <GTranslateSharpIcon />
                </Box>
              </Tooltip>
            )}
          </Box>
        ) : (
          input.dataType === "option" && (
            <Box
              sx={{
                // position: "absolute",
                maxWidth: "calc(100% - 72px)",
                // right: "-4px",
                // top: "0",
                zIndex: "9",
                display: "flex",
                gap: "10px",
                margin: "0 !important",
                alignItems: "center",
              }}
            >
              <Box sx={{ whiteSpace: "nowrap", overflow: "hidden" }}>
                {" "}
                {subHeading({ text: "Is Answer" })}
              </Box>
              <FormControlLabel
                sx={{ margin: "0 0 0 0 !important" }}
                label=""
                control={
                  <Checkbox
                    sx={{
                      margin: "0 !important",
                      "&.MuiButtonBase-root": {
                        padding: "0",
                      },
                    }}
                    style={{ color: "#000000" }}
                    checked={
                      submittedData &&
                      submittedData["correct_answer"] &&
                      submittedData["correct_answer"] !== null &&
                      submittedData["correct_answer"].label === input.label
                        ? true
                        : false
                    }
                    onChange={(event: any) => {
                      handleInputChange(
                        "correct_answer",
                        event.target.checked ? input : null
                      );
                    }}
                  />
                }
              />
            </Box>
          )
        ),
    });
    const sx = input.fullWidth ? fullWidthSx : oneContentWidth;
    switch (input.fieldType) {
      case "image":
        return (
          <Stack
            spacing={"16px"}
            sx={{
              marginTop: i === 1 ? "0 !important" : "",
              ...sx,
              pointerEvents: !isEditable ? "none" : "auto",
            }}
          >
            {headingContent}
            <Box
              sx={{
                border: `1px solid ${globalColors.primary.grey}`, // mostLightGrey, // sets the border color to purple
                borderRadius: "10px",
                padding: "0.69px 0.69px 0.69px 12px",
                color: globalColors.primary.black,
                ...rowSB,
              }}
            >
              {" "}
              {subHeading({
                text:
                  submittedData &&
                  submittedData[input?.label] &&
                  submittedData[input?.label]?.file
                    ? `<img src="${
                        submittedData[input.label]?.file
                      }" alt="image" style="width: 200px; height:200px; object-fit: contain"/>`
                    : "",
                parentSx: { flex: 8, width: "calc(100% - 160px)" },
                sx: {
                  whiteSpace: "nowrap",
                  width: "100%",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                },
              })}{" "}
              <input
                accept="image"
                //   ref={(ref) => {
                //     setFileInputRef(ref);
                //   }}
                multiple
                id="files"
                style={{
                  visibility: "hidden",
                  width: "0",
                  maxHeight: "11px",
                }}
                type="file"
                onChange={(e: {
                  preventDefault: () => void;
                  stopPropagation: () => void;
                  target: { files: any };
                }) => {
                  e.preventDefault();
                  e.stopPropagation();

                  let fileObj = [];
                  const fileA: any[] = [];
                  fileObj.push(e.target.files);
                  for (let i = 0; i < fileObj[0].length; i++) {
                    fileA.push(fileObj[0][i]);
                  }
                  const fileUpload = async () => {
                    const res = await apiRequest({
                      form: true,
                      api: allApis.file_upload,
                      payload: {
                        parent_id: "",
                        // submittedData["Parent ClusterId"],
                        file: fileA[0],
                        created_by: userData?.id,
                        modified_by: userData?.id,
                        parent_model:
                          // content_list.find(
                          //   (item: { model: string }) =>
                          //     item.model === "question"
                          // )?.id ?? "",
                          "",
                      },
                    });

                    handleInputChange(input.label, res ?? fileA[0]);
                  };
                  fileUpload();
                }}
              />
              <Box sx={{ padding: "0 7px" }}>
                <CustomIconButton
                  content={copyIcon}
                  noHover={true}
                  onClick={() => {
                    navigator.clipboard.writeText(
                      `<img src="${
                        submittedData[input.label].file
                      }" alt="image" style="width: 200px; height:200px; object-fit: contain"/>`
                    );

                    copy(
                      `<img src="${
                        submittedData[input.label].file
                      }" alt="image" style="width: 200px; height:200px; object-fit: contain"/>`,
                      {
                        debug: true,
                        onCopy: () => {
                          dispatch(
                            showSnack({
                              message:
                                "Image copied, paste it wherever you want it.",
                              severity: "success",
                              open: true,
                            })
                          );
                        },
                      }
                    );
                  }}
                />
              </Box>
              <label htmlFor="files" className="btn">
                <Box
                  sx={{
                    backgroundColor: "#000000", // You can customize the background color here
                    color: globalColors.primary.white,
                    textTransform: "capitalize",
                    fontWeight: 500,
                    fontSize: "0.875rem !important",
                    borderRadius: "8px",
                    lineHeight: "normal",
                    cursor: "pointer",
                    padding: "9px 10px",
                  }}
                >
                  Choose image
                </Box>
              </label>
            </Box>
          </Stack>
        );

      case "checkbox":
        return (
          <Stack
            spacing={"16px"}
            sx={{
              marginTop: i === 1 ? "0 !important" : "",
              ...sx,
              alignItems: "flex-end",
              justifyContent: "center",
              pt: "26px",
            }}
          >
            {/* {headingContent} */}
            {/* <Box sx={{minHeight:"38.86px",alignItems:"center",display:"flex"}}>
               <Checkbox checked={false}onChange={()=>{
  
            }}/></Box> */}
            <Box
              sx={{
                display: "flex",
                gap: "10px",
                margin: "0 10px 0 0 !important",
                alignItems: "center",
              }}
            >
              {subHeading({ text: input.label })}
              <FormControlLabel
                sx={{ margin: "0 0 0 0 !important" }}
                label=""
                control={
                  <Checkbox
                    sx={{
                      margin: "0 !important",
                      "&.MuiButtonBase-root": {
                        padding: "0",
                      },
                    }}
                    style={{ color: "#000000" }}
                    checked={submittedData["default_languge"] ? true : false}
                    onChange={(event: any) => {
                      handleInputChange(
                        "default_languge",
                        event.target.checked ? true : false
                      );
                    }}
                  />
                }
              />
            </Box>
          </Stack>
        );

      case "autocomplete":
        return (
          <Stack
            spacing={"16px"}
            sx={{
              marginTop: i === 1 ? "0 !important" : "",
              ...sx,
            }}
          >
            {headingContent}
            {input.multiple ? (
              <Stack sx={{ pointerEvents: !isEditable ? "none" : "auto" }}>
                <MultipleAutoComplte
                  {...input}
                  value={
                    submittedData && submittedData[input.label]
                      ? submittedData[input.label]
                      : []
                  }
                  onChange={(val: any) => {
                    handleInputChange(input.label, val);
                  }}
                />
              </Stack>
            ) : (
              ""
            )}
          </Stack>
        );
      case "cktextEditor":
        return (
          <Stack
            spacing={"16px"}
            sx={{
              marginTop: i === 1 ? "0 !important" : "",
              // marginBottom: input.label === "Question" ? "0" : "20.91px",
              ...sx,
              position: "relative",
              pointerEvents: !isEditable ? "none" : "auto",
              borderRadius: "4px",
            }}
          >
            {headingContent}{" "}
            <Box>
              <CustomCkeditor
                {...input}
                value={submittedData[input.label] ?? ""}
                load={submittedData.loader}
                onChange={(val: any) => {
                  if (val !== undefined) {
                    handleInputChange(input.label, val);
                  }
                }}
              />
            </Box>
          </Stack>
        );
      case "extra":
        return (
          <Stack
            spacing={"16px"}
            sx={{
              marginTop: i === 1 ? "0 !important" : "",
              marginBottom: "20.91px",
              ...sx,
              // height: "100px",
            }}
          ></Stack>
        );
      default:
        return <Grid item xs={singlexs} display="flex" key={"default"}></Grid>;
    }
  };
  const singlexs = 6;
  const allFormComp: any = (list: inputProp[], index: number) => {
    return list?.map((input: inputProp, i: number) => {
      return (
        <>
          <Grid
            item
            xs={input.fullWidth ? 12 : singlexs}
            display="flex"
            key={`${input.label}=${i}`}
            sx={
              input.fullWidth
                ? {
                    borderRadius: "8px",
                    border: "1px solid #e5e7eb",
                    backgroundColor: "background.paper",
                  }
                : {
                    maxWidth: "calc(50% - 7.5px) !important",
                    borderRadius: "8px",
                    border: "1px solid #e5e7eb",
                    backgroundColor: "background.paper",
                  }
            }
            padding={"16px !important"}
            {...input?.grid}
          >
            {input.label === "Question Tags" && index > 0 ? (
              <></>
            ) : (
              singleForm(input, i)
            )}
          </Grid>{" "}
          {input.label === "Question" &&
            (value === 0 || value === 1) &&
            isEditable && (
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingRight: "16px",
                }}
              >
                {steps.length > 1 && (
                  <Tooltip title={`Translate Options`} arrow>
                    <Box
                      sx={{
                        minWidth: "fit-content",
                        padding: "2px !important",
                        margin: "0",
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        setSubmittedData((p) => {
                          return {
                            ...p,
                            loader: true,
                            loader_text: `Translating Options to hindi.`,
                          };
                        });
                        const response: any = await apiRequest({
                          api: `content/v3/translate-text/`,
                          payload: formatPayloadTranslateEach(
                            value === 0 ? submittedData : allSubmittedData[0],
                            "Option"
                          ),
                          method: "POST",
                        });
                        const newData = [];
                        newData[0] =
                          value === 0 ? submittedData : allSubmittedData[0];
                        newData[1] = getHindiData(response);
                        setAllSubmittedData(newData);

                        setSubmittedData({
                          ...newData[value],
                          loader: false,
                        });
                      }}
                    >
                      <GTranslateSharpIcon />
                    </Box>
                  </Tooltip>
                )}
              </Box>
            )}
        </>
      );
    });
  };
  const bottomHeader = (val: 0 | 1) => {
    return (
      <Box
        sx={{
          width: "100%",
          ...rowSB,
          padding: "8px",
          boxSizing: "border-box",
          bgcolor: "background.paper",
          borderRadius: "8px 8px 0 0",
          border: "1px solid #e5e7eb",

          borderBottom: "none",
        }}
      >
        <Box sx={{ display: "flex", width: "calc(100% - 202.33px)" }}>
          {value + 1 === steps.length && steps.length > 1 ? (
            <CustomIconButton
              {...{
                disabled: false,
                onClick: () => {
                  handleChange(0);
                },
                sx: { minWidth: "fit-content" },
                variant: "outlined",
              }}
              content="Back"
              icon={<ArrowBack sx={{ height: "16px" }} />}
            />
          ) : (
            ""
          )}
          <Box
            sx={{
              width:
                value + 1 === steps.length && steps.length > 1
                  ? "calc(100% - 60px)"
                  : "100%",
              justifyContent: "center",
              display: "flex",
              alignItems: "center",
            }}
          >
            {" "}
          </Box>
        </Box>
        <Box sx={{ minWidth: "fit-content" }}>
          {/* <CustomContainedButton
              key="Edit"
              otherProps={{
                // disabled: submittedData && Object.values(submittedData).every(c => c === undefined || c === null || c === ''),
                onClick: () => {
                 reviewLater(question_id)
                },
                sx: { minWidth: "fit-content" ,mr:"8px"},
              }}
              content={" Mark for Later"}
            /> */}

          {value + 1 === steps.length ? (
            <CustomContainedButton
              otherProps={{
                // disabled: isAllMandatoryFieldsFilled(),
                onClick: () => {
                  handleOpenDialog("corrected");
                },
                sx: { minWidth: "fit-content" },
              }}
              loading={
                submittedData &&
                submittedData.loader &&
                submittedData.clicked_button_type
                  ? submittedData.loader
                  : undefined
              }
              icon="Mark as Corrected"
              content={<PlaylistAddCheckOutlinedIcon sx={{ height: "16px" }} />}
            />
          ) : (
            <CustomContainedButton
              otherProps={{
                disabled: false,
                onClick: () => {
                  handleChange(1, "No");
                },
                sx: { minWidth: "60px" },
              }}
              icon="Next"
              content={<ArrowForwardIcon sx={{ height: "16px" }} />}
            />
          )}
          {value + 1 === steps.length ? (
            ""
          ) : (
            <CustomContainedButton
              otherProps={{
                disabled: false,
                onClick: () => {
                  handleChange(1);
                },
                sx: { minWidth: "60px", ml: "8px" },
              }}
              icon={
                <>
                  <GTranslateSharpIcon sx={{ height: "16px" }} /> Translate{" "}
                  <ArrowForwardIcon sx={{ height: "16px" }} />
                </>
              }
              content={"Next"}
            />
          )}
          {/* {openComfirm.open && (
            <ConfirmationDialog
              title={"Reviewed Question Successfully."}
              content={
                <Box
                  sx={{
                    height: "calc(100dvh - 190.67px)",
                    minHeight: "calc(100dvh - 190.67px)",
                    boxSizing: "border-box",
                    maxWidth: "500px",
                  }}
                >
                  <UpdatedQuestionPreviewWrapper
                    questionEditData={openComfirm.res}
                  />
                </Box>
              }
              customWidth="fit-content"
              yesButtonText="Review Next Question"
              noButtonText="Go to List"
              actions={!getNextQUeAvailable() ? [] : undefined}
              open={openComfirm.open}
              onClose={() => {
  //                const navigateBack = () => {
  //   navigate("/contentFeedback");
  // };
                setConfirmation({ open: false, res: null });
                setSnackbarOpen(true);
                setDialogOpen(false);
                setIsSubmitting(false);
                localStorage.removeItem(
                  btoa(`cf-lists-${getServerEnvironment()}`)
                );
              }}
              onSubmit={async () => {
                const singleQue = getNextQUeAvailable();
                if (singleQue) {
                  // ✅ Example usage:
                  if (singleQue) {
                    navigate(
                      `/contentFeedback/QuestionAddingForm/${singleQue?.que}/${
                        singleQue?.id ?? ""
                      }`,
                      { replace: true }
                    );
                    setHasFetched(false);
                    setSubmittedData({ loader: true });
                    await setConfirmation({ open: false, res: null });
                    await setSnackbarOpen(true);
                    await setDialogOpen(false);
                    await setIsSubmitting(false);
                  }
                  // 👉 { id: 678, que: 49507 }
                }
                // ,
                // btoa(JSON.stringify({quelist:(reportedQuestions.results ?? []),
                //   // mast
                // }))
              }}
            />
          )} */}
          {/* <ContentConfirmationDialog
            open={isDialogOpen}
            onClose={handleCloseDialog}
            onConfirm={handleConfirmDialog}
            actionType={dialogActionType}
            // row={row}
            isSubmitting={isSubmitting}
          /> */}
        </Box>
      </Box>
    );
  };
  const content = (val: 0 | 1) => {
    return (
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: "100%",
        }}
      >
        <Typography
          variant="h6"
          fontSize={"0.8rem"}
          color="#838383"
          m={"2px 16px"}
          width={"calc(100% - 32px)"}
          sx={
            {
              // overflow: "hidden",
              // textOverflow: "ellipsis",
            }
          }
        >
          {newPath
            ? `New Path - ${newPath.exam} • ${newPath.goal} • ${
                newPath.section
              } • ${newPath.topic} • ${newPath.subtopic} • ${
                newPath.cluster.name
              }${newPath.cluster.type ? ` • ${newPath.cluster.type}` : ""}${
                newPath.cluster.description
                  ? ` • ${newPath.cluster.description}`
                  : ""
              }`
            : `${filters.exam} • ${filters.goal} • ${filters.section} • ${
                filters.topic
              } • ${filters.subtopic} • ${filters.cluster.name}${
                filters.cluster.type ? ` • ${filters.cluster.type}` : ""
              }${
                filters.cluster.description
                  ? ` • ${filters.cluster.description}`
                  : ""
              }`}{" "}
          •{" "}
          <Chip
            label={`Que. id: #${question_id}`}
            size="small"
            sx={{
              border: "1px solid rgb(0 0 0 / 60%)",
              borderRadius: "4px",
              padding: "0",
              color: "rgb(0 0 0 / 60%)",
              fontSize: "0.75rem",
              background: "transparent",
              "& .MuiChip-label": {
                padding: "0 3px !important",
              },
              ...singleLineEllipsis,
              ml: "10px",
            }}
          />
        </Typography>
        <Box
          className="scrollBluePrimarythin"
          sx={{
            overflowY: "scroll",
            overflowX: "hidden",
            // height: "calc(100% - 23.69px)",
            flexGrow: 8,
          }}
        >
          {" "}
          <Grid
            container
            key={"QuestionFormComponentMock"}
            rowSpacing={1}
            columnGap={""}
            sx={{
              gap: "15px",
              // padding: "24px 19px",
              minHeight: "calc(100% - 32px)",
              width: "calc(100% - 32px)",
              boxSizing: "border-box",
              margin: "8px 16px",
            }}
          >
            {allFormComp(allInputs(tags_list), val)}
          </Grid>
        </Box>
      </Box>
    );
  };
  return (
    <Stack height="100%" width="100%" bgcolor="#f9fafb">
      {submittedData.loader === true || isSubmitting ? (
        <LoaderBackdrop
          open={true}
          text={submittedData.loader_text ?? "Loading..."}
        />
      ) : (
        ""
      )}
      <Stack
        margin={"0"}
        sx={{
          // overflow: "hidden",
          height: "100%",
          width: "100%",
          background: "transparent",
        }}
        direction={"row"}
        spacing={"10px"}
      >
        <style>{`img {max-width:100%}`}</style>
        {/* left */}

        {
          <Box
            style={{
              width: "calc(100% - 408px)",
              minWidth: "calc(60% - 8px)",
              height: "100%",
            }}
          >
            <Box
              sx={{
                width: "100%",
                mb: "10px",
                // ...rowSB,
                padding: "8px",
                boxSizing: "border-box",
                bgcolor: "background.paper",
                borderBottom: "1px solid #e5e7eb",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box sx={{ display: "flex", minWidth: "165.73px" }}>
                {" "}
                <Box
                  onClick={() => {
                    if (onClose) {
                      onClose();
                    }
                  }}
                  sx={{
                    cursor: "pointer",
                    width: "fit-content",
                    mr: "2px",
                    maxHeight: "24px",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <ArrowBack sx={{ maxHeight: "16px", width: "16px" }} />
                </Box>
                <Typography
                  fontWeight={"bold"}
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "calc(100% - 18px)",
                  }}
                >
                  Question Update
                </Typography>
              </Box>
              <Box
                maxWidth={"400px"}
                width={"calc(100% - 170.4px)"}
                margin="0 5px"
              >
                <CssStepperHorizontal
                  activeStep={value}
                  alternativeLabel
                  connector={<ColorlibConnector />}
                >
                  {steps.map((label, i) => (
                    <Step key={label} expanded={true}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
                </CssStepperHorizontal>
              </Box>
            </Box>

            <Paper
              style={{
                width: "100%",
                minWidth: "100%",
                margin: "0 0 8px",
                height: "calc(100% - 110.67px)",
                // borderRadius: "8px",
                // border: "1px solid #e5e7eb",
                // padding: "8px 0",
                boxSizing: "border-box",
                position: "relative",
                background: "transparent",
                boxShadow: "none",
              }}
            >
              {/* <Typography
                variant="subtitle1"
                gutterBottom
                sx={{
                  position: "absolute",
                  top: "-9px",
                  left: 16,
                  bgcolor: "white !important",
                  zIndex: "99",
                  px: 1,
                  borderRadius: "8px",
                  border: "1px solid black",
                }}
              >
                Question
              </Typography> */}
              {content(value)}
            </Paper>

            {bottomHeader(value)}
          </Box>
        }
        <ContentConfirmationDialog
          open={dialogState.open}
          newPath={newPath}
          filters={filters}
          onClose={() => {
            setDialogState((prev) => ({ ...prev, open: false }));
          }}
          onConfirm={handleConfirmDialog}
          actionType={dialogState.actionType}
          // row={row}
          isSubmitting={isSubmitting}
        />
        {/* preview */}
        <Grid
          container
          width="40%"
          maxWidth="400px"
          key={"QuestionFormComponentMock"}
          rowSpacing={1}
          columnGap={""}
          sx={{
            gap: "0 15px",
            paddingRight: "0",
            paddingTop: "0",
            height: "calc(100% - 32px)",
            m: "16px 16px 16px 8px !important",
          }}
        >
          <MobileEmulator
            submittedData={submittedData}
            languge={{
              handleQuizLanguageToggled: () => {},
              languages: steps,
              selectedLang: value === 0 ? steps[0] : steps[1],
            }}
          />
        </Grid>
      </Stack>
    </Stack>
  );
}

export default FormComp;
